import http from '@/utils/http'

const querySensoresVirtuaisMixin = {
  data() {
    return {
      equipamentosComSensoresVirtuais: {},
    }
  },
  async beforeMount() {
    await this.loadSensoresVirtuais()
  },
  methods: {
    async loadSensoresVirtuais() {
      // http.get retorna null em erro (ja exibe o toast). Sem o fallback, o
      // acesso a .sensoresVirtual lanca e aborta o beforeMount de quem usa o
      // mixin, derrubando tambem o que vinha depois da chamada.
      const result = await http
        .get(`local/${this.localId}/sensor/virtual`)
        .then((e) => e?.sensoresVirtual ?? [])

      this.equipamentosComSensoresVirtuais = result.reduce((acc, sensor) => {
        if (!acc[sensor.equipamentoId]) {
          acc[sensor.equipamentoId] = {
            id: sensor.equipamentoId,
            nome: sensor.equipamentoNome,
            sensoresVirtuais: [],
          }
        }

        acc[sensor.equipamentoId].sensoresVirtuais.push(sensor)

        return acc
      }, {})

      return this.equipamentosComSensoresVirtuais
    },
  },
}

export default querySensoresVirtuaisMixin
